module.exports = __webpack_public_path__ + "media/flags/016-spain-d85161cd.svg";